export const getInfoWindowString = ( props ) => {
	const { hit, count, current } = props;
	// console.log( 'hit', hit );
	if ( ! hit ) {
		return '';
	}

	const isNeighborhood = hit.type === 'Neighborhood';
	const typeLabel = () => {
		if ( isNeighborhood ) {
			return 'Neighborhood';
		}
		return hit.type.toLowerCase().includes( 'home' ) ? 'Available Home' : 'Floorplan';
	};

	const getControls = () => {
		if ( count === 1 ) {
			return '';
		}
		return (
			`<div class="tw-flex tw-justify-center tw-mb-2 tw-space-x-2 ">
				<button id="info-window-control-prev" aria-label="Previous" class="tw-bg-white tw-shadow tw-rounded-full tw-group hover:tw-bg-platinum tw-px-2">
					<svg class='tw-block tw-rotate-90' aria-hidden="true" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class="tw-fill-charcoal group-hover:tw-fill-slate" d="M5.99911 6.70192L0.691406 1.39422L1.39911 0.686523L5.99911 5.28652L10.5991 0.686523L11.3068 1.39422L5.99911 6.70192Z" />
					</svg>
				</button>
				<span class="tw-px-4 tw-py-1 tw-bg-white tw-font-medium tw-text-sm tw-rounded-full tw-shadow">
					${ current + 1 } of ${ count }
				</span>
				<button id="info-window-control-next" aria-label="Next" class="tw-bg-white tw-shadow tw-rounded-full tw-group hover:tw-bg-platinum tw-px-2">
					<svg class='tw-block -tw-rotate-90' aria-hidden="true" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path class="tw-fill-charcoal group-hover:tw-fill-slate" d="M5.99911 6.70192L0.691406 1.39422L1.39911 0.686523L5.99911 5.28652L10.5991 0.686523L11.3068 1.39422L5.99911 6.70192Z" />
					</svg>
				</button>
			</div>`
		);
	};

	return ( `
		<div class="tw-relative">
			${ getControls() }
			<div class="tw-flex tw-bg-white tw-shadow">
				<div style="width:136px;min-height:100%;flex:none;">
					<img class="" style="width:100%;object-fit:cover;" src="${ hit.image?.medium_large }" />
				</div>
				<div class="tw-px-2 tw-py-4 tw-w-full">
					<div>
						<div class="tw-uppercase tw-text-slate tw-font-medium tw-text-xxxs tw-tracking-wide tw-mb-1 tw-font-sans">${ typeLabel() } </div>
						<h3 class="tw-font-medium tw-text-charcoal tw-text-lg tw-mb-2 tw-font-sans">
							<a href="${ hit.url }" class="tw-text-charcoal hover:tw-text-kiwi hover:tw-no-underline tw-border-apple tw-border-b-2 tw-leading-normal tw-underline-offset-4">${ hit.title }</a>
						</h3>
						<div class="tw-flex tw-flex-col">
							<span class="tw-font-medium tw-text-xxs tw-text-charcoal tw-pb-1 tw-font-sans">${ hit.cities ? hit.cities[ 0 ] : '' }, ${ hit.state_alpha_2_code }</span>
							<span class="tw-font-medium tw-text-xxs tw-text-charcoal tw-font-sans">${ hit.price_copy }</span>
						</div>
					</div>
					<div class="tw-flex tw-flex-row tw-items-end tw-justify-between tw-mt-2">
						<div class="tw-w-full tw-border-r tw-border-steel">
							<div class="tw-flex tw-flex-col tw-items-center tw-h-full tw-mx-2">
								<span class="tw-pb-1 tw-text-xxs tw-text-ash tw-text-center tw-whitespace-nowrap tw-font-medium tw-font-sans">
									${ hit.min_sq_feet ? hit.min_sq_feet.toLocaleString() : '' }
									${ hit.max_sq_feet ? `-${ hit.max_sq_feet.toLocaleString() }` : '' }
								</span>
								<span class="tw-tracking-wide tw-text-center tw-text-slate tw-uppercase tw-text-xxxxs tw-font-bold tw-font-sans">SQ. FT.</span>
							</div>
						</div>
						<div class="tw-w-full tw-border-r tw-border-steel">
							<div class="tw-flex tw-flex-col tw-justify-end tw-h-full tw-px-2">
								<span class="pb-1 tw-text-xxs tw-text-ash tw-text-center tw-font-medium tw-font-sans">
									${ hit.max_bedrooms === hit.min_bedrooms || ! hit.max_bedrooms ? hit.min_bedrooms : `${ hit.min_bedrooms }–${ hit.max_bedrooms }` }
								</span>
								<span class="tw-tracking-wide tw-text-center tw-text-slate tw-uppercase tw-text-xxxxs tw-font-bold tw-font-sans">Bed</span>
							</div>
						</div>
						<div class="tw-w-full tw-border-r tw-border-steel">
							<div class="tw-flex tw-flex-col tw-justify-end tw-h-full tw-px-2">
								<span class="pb-1 tw-text-xxs tw-text-ash tw-text-center tw-font-medium tw-font-sans tw-whitespace-nowrap">
									${ hit.max_bathrooms === hit.min_bathrooms || ! hit.max_bathrooms ? hit.min_bathrooms : `${ hit.min_bathrooms }–${ hit.max_bathrooms }` }
								</span>
								<span class="tw-tracking-wide tw-text-center tw-text-slate tw-uppercase tw-text-xxxxs tw-font-bold tw-font-sans">Bath</span>
							</div>
						</div>
						<div class="tw-w-full">
							<div class="tw-flex tw-flex-col tw-justify-end tw-h-full tw-px-2">
								<span class="pb-1 tw-text-xxs tw-text-ash tw-text-center tw-font-medium tw-font-sans">
									${ hit.max_garage === hit.min_garage || ! hit.max_garage ? hit.min_garage : `${ hit.min_garage }–${ hit.max_garage }` }
								</span>
								<span class="tw-tracking-wide tw-text-center tw-text-slate tw-uppercase tw-text-xxxxs tw-font-bold tw-font-sans">Bay Garage</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	` );
};
